"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextPaginatedRequestResolver = void 0;
var NextPaginatedRequestResolver = /** @class */ (function () {
    function NextPaginatedRequestResolver() {
    }
    NextPaginatedRequestResolver.resolve = function (operation, request, pagination) {
        var currentPage = operation.firstPageIndex === 1 ? pagination.page : pagination.page + 1;
        var hasNextPage = pagination.total > pagination.pageSize * currentPage;
        if (!hasNextPage) {
            return null;
        }
        var nextParams = __assign({}, request);
        if (pagination.cursor) {
            nextParams.cursor = pagination.cursor;
        }
        else {
            nextParams.offset = (pagination.page + 1) * (nextParams.limit || 500);
        }
        return nextParams;
    };
    return NextPaginatedRequestResolver;
}());
exports.NextPaginatedRequestResolver = NextPaginatedRequestResolver;
//# sourceMappingURL=NextPaginatedRequestResolver.js.map